import React from "react";
import { FiPlus, FiUpload, FiDownload, FiFileText } from "react-icons/fi";

interface ScoringInstructionsToolbarProps {
	totalScore: number;
	onTotalScoreChange: (value: number) => void;
	onImport: () => void;
	onExport: () => void;
	onDownloadTemplate: () => void;
	onAddRow: () => void;
	isSaving: boolean;
	isValid: boolean;
	onSave: () => void;
}

export const ScoringInstructionsToolbar: React.FC<ScoringInstructionsToolbarProps> = ({
	totalScore,
	onTotalScoreChange,
	onImport,
	onExport,
	onDownloadTemplate,
	onAddRow,
	isSaving,
	isValid,
	onSave,
}) => {
	const handleTotalScoreChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = parseInt(e.target.value, 10);
		if (!isNaN(value)) {
			onTotalScoreChange(value);
		}
	};

	return (
		<div className="mb-4 flex flex-col gap-4">
			<div className="flex items-center gap-4">
				<label className="flex items-center gap-2 font-roboto text-sm font-medium text-gray-700">
					Total Score:
					<input
						type="number"
						value={totalScore}
						onChange={handleTotalScoreChange}
						min={1}
						className="w-24 rounded border border-gray-300 px-2 py-1 font-roboto text-sm focus:border-royal-blue focus:outline-none"
						data-testid="total-score-input"
					/>
				</label>
			</div>
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-2">
					<button
						type="button"
						onClick={onDownloadTemplate}
						className="flex items-center gap-1 rounded border border-gray-300 px-3 py-1.5 font-roboto text-sm text-gray-600 hover:bg-gray-50"
						data-testid="download-template-btn"
					>
						<FiFileText size={14} />
						Download Template
					</button>
					<button
						type="button"
						onClick={onImport}
						className="flex items-center gap-1 rounded border border-gray-300 px-3 py-1.5 font-roboto text-sm text-gray-600 hover:bg-gray-50"
						data-testid="import-excel-btn"
					>
						<FiUpload size={14} />
						Import Excel
					</button>
					<button
						type="button"
						onClick={onExport}
						className="flex items-center gap-1 rounded border border-gray-300 px-3 py-1.5 font-roboto text-sm text-gray-600 hover:bg-gray-50"
						data-testid="export-excel-btn"
					>
						<FiDownload size={14} />
						Export Excel
					</button>
					<button
						type="button"
						onClick={onAddRow}
						className="flex items-center gap-1 rounded border border-royal-blue px-3 py-1.5 font-roboto text-sm text-royal-blue hover:bg-blue-50"
						data-testid="add-row-btn"
					>
						<FiPlus size={14} />
						Add Row
					</button>
				</div>
				<button
					type="button"
					onClick={onSave}
					disabled={!isValid || isSaving}
					className="rounded bg-royal-blue px-6 py-1.5 font-roboto text-sm font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
					data-testid="save-scoring-btn"
				>
					{isSaving ? "Saving..." : "Save"}
				</button>
			</div>
		</div>
	);
};
